module.exports = __webpack_public_path__ + "img/amway_logo_white.ad066994.svg";